import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Rx = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="Rx icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51 20H48V59C48 60.6417 46.629 62 45 62H19C17.371 62 16 60.6417 16 59V20H13V9H17V5C17 3.35832 18.371 2 20 2L44 2C45.629 2 47 3.35832 47 5V9H51V20ZM16 17H48V12L35 12V9H44V5L20 5V9H23V12H16V17ZM19 20H45V59.0377H19V52H38V25L19 25.0852V20ZM19 28V49H35V28H19Z"
    />
    <path
      className={`color-iconPrimary-disabled ${pathClass}`}
      d="M19 49V28H35V49H19Z"
    />
  </svg>
)
